import CustomPrintBadge from './CustomPrintBadge';

export default CustomPrintBadge;
